export default __webpack_public_path__ + "static/media/Histoire-geo.494c87fc.png";